module.exports = __webpack_public_path__ + "static/sca3-8f6b8a8cae7ff62a40c65e7f8a680b53.png";